import Template from './Template'

class SingleOfferTemplate extends Template{
    constructor(props = {}) {
        super(props)
        this.campaign = props.campaign || {}
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return super._isLoadFinish()
    }
}
export default SingleOfferTemplate